var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorDropIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7191 4.21683C11.2372 3.73502 10.456 3.73502 9.97411 4.21683L2.99311 11.1998C2.29849 11.8938 1.9082 12.8354 1.9082 13.8173C1.9082 14.7992 2.29849 15.7408 2.99311 16.4348L6.48311 19.9258C7.17714 20.6208 8.11898 21.0112 9.10111 21.0112C10.0833 21.0112 11.0251 20.6208 11.7191 19.9258L17.3911 14.2538L20.0421 13.9588C20.2776 13.9324 20.4772 13.7735 20.5556 13.5499C20.634 13.3263 20.5775 13.0776 20.4101 12.9098L11.7191 4.21683Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2417 17.2578L18.5877 20.5658C18.2318 21.2777 18.3716 22.1374 18.9347 22.6998V22.6998C19.2812 23.0471 19.7516 23.2423 20.2422 23.2423C20.7328 23.2423 21.2032 23.0471 21.5497 22.6998V22.6998C22.1125 22.1372 22.2519 21.2774 21.8957 20.5658L20.2417 17.2578Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8418 9.34881V3.75781C4.8418 2.10096 6.18494 0.757813 7.8418 0.757812V0.757812C9.49865 0.757813 10.8418 2.10096 10.8418 3.75781V12.0078",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorDropIcon);
export default __webpack_public_path__ + "static/media/color-drop-icon.9f2988ff84187c21074a4a51d8788025.svg";
export { ForwardRef as ReactComponent };